export default {
    global: {
        inputPlaceholder: '请输入',
	    selectPlaceholder: '请选择'
    },
    login: {
        login: '登录',
        normal: '普通用户',
        admin: '管理员'
    },
    goods: {
        goods: '商品中心',
	    list: '商品中心',
        detail: '商品详情',
        table: {
	        index: '序号',
	        mainPicUrl: '商品图片',
	        code: '商品编码',
	        codeType: '商品类型',
            name: '商品名称',
	        putawayStatus: '上架状态',
	        inStockStatus: '库存状态',
	        action: '操作',
	        detail: '详情'
        },
	    reset: '重置',
	    search: '查询'
    },
    goodsDetail: {
        table: {
	        categoryGroupCode: '类目树',
	        categoryName: '类目',
	        categoryCode: '类目编码',
	        code: 'SKU编码',
	        salesAttrs: '销售属性',
	        salesPrice: '销售价',
	        shopSalesPrice: '销售价(店铺值)',
	        standardPrice: '吊牌价',
	        shopStandardPrice: '吊牌价(店铺值)',
	        curInventory: '总库存',
	        putawayStatus: '上下架状态',
	        usableInventory: '总可用库存',
	        lockInventory: '总锁定库存',
	        color: '颜色',
	        size: '尺寸',
	        colorCode: '颜色编码',
	        picture: '图片',
	        video: '视频',
	        isMainColor: '主色',
	        thumbnail: '缩略图(pim推送的色块图)'
        },
	    memberStatus: '会员优先购',
	    memberLevel: '会员等级'
    },
    customer: {
        customer: '客户人群',
	    list: '客户人群',
	    detail: '客户详情',
	    table: {
            index: '序号',
		    userCode: '客户编号',
		    outerMemberId: '会员编号',
		    desensitizationMobile: '手机号码',
		    shopName: '注册店铺',
		    media: '店铺备注',
		    terminalTitle: '注册应用',
		    createTime: '注册时间',
		    action: '操作',
		    search: '查看'
	    }
    },
    customerDetail: {
        table: {
            policyCode: '协议code',
	        policyAcceptStatus: '接受状态',
	        orderCode: '订单编号',
	        actualAmountPaid: '订单金额',
	        payWay: '支付方式',
	        orderStatus: '订单状态',
	        orderCreatedTime: '创建时间',
	        action: '操作',
	        search: '查看',
	        receiver: '收货人姓名',
	        mobile: '收货人联系方式',
	        addressDetail: '详细地址',
	        postalCode: '邮编',
	        isDefault: '是否默认',
	        createTime: '创建时间',
	        updateTime: '时间',
	        ipAddress: 'IP',
	        ipAddressArea: '地区',
	        shopName: '店铺'
        }
    },
    order: {
        order: '订单中心',
	    orderList: '订单查询',
	    refundList: '售后管理',
        orderDetail: '订单详情',
	    refundDetail: '售后详情',
	    tabLabel: {
		    all: '全部',
		    noPay: '待付款',
		    noSend: '待发货',
		    send: '已发货',
		    success: '交易成功',
		    close: '交易关闭',
		    orderDetail: '订单详情',
		    logistics: '收货和物流信息',
		    invoice: '发票信息',
		    refund: '退货信息',
		    exchange: '换货信息'
	    },
	    card: {
		    order: '订单信息',
            logistics: '收货和物流信息',
            invoice: '交易信息',
            exchange: '换货信息'
	    },
	    paramLabel: {
		    orderCodesStr: '订单编号',
		    memberMobileNumbersStr: '会员手机号',
		    shipmentNumber: '订单物流单号',
		    skuCodeList: 'SKU编号',
		    consigneeName: '收货人姓名',
		    consigneeMobileNumber: '收货人手机号',
		    memberCode: '客户编号',
		    deliveryMethods: '配送方式',
		    orderTypes: '订单类型',
		    paymentMethods: '付款方式',
		    paymentStatus: '付款状态',
		    sourceList: '来源类型',
		    orderDate: '下单时间',
		    paidDate: '付款时间'
	    },
	    paymentStatus: {
            '0': '未付款',
		    '1': '已付款'
	    },
        table: {
            index: '序号',
	        orderCode: '订单编号',
	        memberCode: '客户编号',
	        desensitizationMobile: '会员手机号',
	        orderStatusDescription: '订单状态',
	        orderAmount: '商品总额',
	        actualAmountPaid: '需付/实付金额',
	        orderCreatedTime:'创建时间',
	        orderItemCode: '子订单编号',
	        refundCode: '退单编号',
	        returnGoodsCode: 'sku编码',
	        returnGoodsNum: '数量',
	        refundFee: '退款金额',
	        refundStatusStr: '退单状态',
	        createTime: '创建时间',
	        goodsPicPath: '图片',
	        goodsName: '商品名称',
	        goodsItemCode: 'item编码',
	        goodsCode: 'sku编号',
	        orderItem: '子订单编号',
	        goodsSalePrice: '销售价格(元)',
	        goodsQuantity: '数量',
	        payPayment: '子订单实付金额(元)',
	        payWay: '支付方式',
	        payNo: '支付流水号',
	        payStep: '支付状态',
	        payFee: '支付金额',
	        paidTime: '支付时间',
	        giftFlag: '是否赠品',
	        goodsTagPrice: '吊牌价(元)',
	        finalPayPayment: '子订单实付金额(元)',
	        point: '子订单实付积分(分)',
	        itemDiscountAmount: '子订单优惠金额(元)',
	        taskTypeName: '优惠类型',
	        marketingName: '优惠明细',
	        discount: '优惠金额',
	        action: '操作',
	        search: '查看'
        },
	    other: {
		    orderMoney: '商品总额',
		    discountAmount: '活动总优惠',
		    pointFee: '积分抵扣',
		    point: '使用积分',
		    orderPostFee: '运费',
		    orderRealMoney: '需付/实付金额'
	    }
    },
    orderDetail: {
        order: {
	        orderCode: '订单编号',
	        desensitizationMobile: '会员手机号',
	        orderStatusStr: '订单状态',
	        shopName: '所属店铺',
	        orderTypeDes: '订单类型',
	        createdDate: '创建时间',
	        typeOfPackaging: '包装类型',
	        terminalType: '渠道来源',
	        memberCode: '客户编号',
	        source: '来源类型',
	        media: '来源名称',
	        receiptCode: '关联小票信息',
	        buyerMemo: '买家备注',
	        sellerMemo: '卖家备注'
        },
	    logistics: {
            receiver: '收货人信息',
		    package: '物流信息',
		    receiverLastName: '姓',
		    receiverFirstName: '名',
		    receiverPhone: '手机号码',
		    receiverTelephone: '固定电话',
		    receiverEmail: '邮箱',
		    deliveryTypeName: '配送方式',
		    receiverAddr: '收货地址'
	    },
        invoice: {
            invoice: '需要发票',
	        invoiceTypeStr: '发票类型',
	        invoiceBody: '发票内容',
	        invoiceTitleStr: '发票抬头',
	        invoiceCompanyName: '单位名称',
	        invoiceTaxNo: '纳税人识别号',
	        invoiceCompanyAddr: '注册地址',
	        invoiceTelephone: '注册电话',
	        invoiceBank: '开户银行',
	        invoiceBankAccount: '银行账号',
	        receiverName: '收票人姓名',
	        receiverPhone: '收票人手机号',
	        receiverMail: '电子邮箱',
	        receiverAddr: '收票人地址'
        }
    },
    industry: {
        industry: '行业数据'
    },
    logistics: {
        logistics: '物流查询'
    },
    servicio: {
        servicio: '客服',
	    overview: '客服总览',
	    chatLogs: '聊天记录',
	    callLogs: '通话记录',
	    setting: '接待设置',
	    todo: '待办事项',
	    monitoring: '接待监控',
	    message: '消息中心',
	    offlineMessage: '离线留言',
	    sceneSetting: '场景配置',
	    phrase: '快捷短语'
    },
    robot: {
	    robot: '智能机器人',
        qa: {
            qa: '问答管理',
            basic: '基础问答',
            goods: '商品问答',
            goodsDetail: '商品详情',
            size: '尺码问答',
			highFrequency: '高频问题分析',
			highFrequencyDetail: '查看对话',
        },
		qdata: '问答数据',
		dataOverview: '问答数据总览',
	    speech: '话术管理',
	    interactive: '互动服务窗',
	    lcheck: 'LLM数据审核',
		lcheckChatDetail: '会话详情'
    },
    manage: {
        manage: '设置',
	    shop: '商铺管理',
	    group: '人员分配',
	    user: '客服资源',
	    role: '系统角色',
	    log: {
            log: '日志',
		    action: '操作日志',
		    export: '导出详情',
		    import: '导入详情'
	    }
    }
}
